import { HelpCircle } from 'lucide-react';
import { Badge } from './ui/badge';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';

const FAQ = () => {
  const faqs = [
    {
      question: 'What should I do if I find a snake in my house?',
      answer: 'Stay calm and keep a safe distance of at least 6 feet from the snake. Keep children and pets away from the area. Do not try to catch or kill the snake. Call our snake catcher number immediately at +91 8310755854 and keep an eye on the snake until help arrives.',
    },
    {
      question: 'How quickly can your snake catcher reach my location in Bangalore?',
      answer: 'We cover a 10km radius from Babusapalya and can typically reach within 15-30 minutes depending on traffic. For areas like Kalyan Nagar, Hennur, Horamavu, Banaswadi, HRBR Layout, Kammanahalli, and Ramamurthy Nagar, we often arrive within 15-20 minutes.',
    },
    {
      question: 'What is your snake rescue number for emergencies?',
      answer: 'For urgent snake removal, call Alhan Nawaz at +91 8310755854 or Mohan K at +91 9845080903. Both numbers are available 24/7 for snake emergencies in Bangalore. You can also WhatsApp us with photos of the snake for quick identification.',
    },
    {
      question: 'Do you charge for snake rescue services in Bangalore?',
      answer: 'We provide snake rescue services at reasonable rates. For residential emergencies, our charges are minimal. Corporate contracts and awareness programs have separate pricing. Contact us for specific rates.',
    },
    {
      question: 'What happens to the snake after you catch it?',
      answer: 'All rescued snakes are safely released in their natural habitats, typically in forested areas away from human settlements. We follow wildlife guidelines to ensure the snake\'s safety and prevent it from returning to populated areas.',
    },
    {
      question: 'Can you help identify if a snake is venomous?',
      answer: 'Yes! Send us a photo via WhatsApp and we can help identify the snake species. Common Bangalore snakes include Spectacled Cobra, Russell\'s Viper, Common Krait, Rat Snake, and Checkered Keelback. Never try to handle any snake yourself.',
    },
    {
      question: 'Which areas in Bangalore do you cover for snake rescue?',
      answer: 'We serve a 10km radius from Bangalore 560043 including: Babusapalya, Kalyan Nagar, Hennur, Horamavu, Banaswadi, HRBR Layout, Kammanahalli, Ramamurthy Nagar, KR Puram, Hebbal, Yelahanka, RT Nagar, and Airport area. Call to check if we cover your locality.',
    },
    {
      question: 'Is your snake rescue service available 24/7?',
      answer: 'Yes, our snake catcher service is available 24 hours, 7 days a week. Snakes are often found at night or early morning, especially during monsoon. We respond to all emergency calls regardless of time - snake in room help is just a call away!',
    },
  ];

  return (
    <section 
      id="faq"
      className="py-20 md:py-32 bg-[#EAE7DF]"
      data-testid="faq-section"
    >
      <div className="max-w-4xl mx-auto px-6 md:px-12 lg:px-24">
        {/* Section Header */}
        <div className="text-center mb-16">
          <Badge variant="outline" className="mb-4 text-[#2A4B35] border-[#2A4B35]">
            <HelpCircle className="w-3 h-3 mr-1" />
            FAQ
          </Badge>
          <h2 
            className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1A1D1A] mb-4"
            style={{ fontFamily: 'Outfit, sans-serif' }}
            data-testid="faq-heading"
          >
            Snake Rescue Bangalore - FAQs
          </h2>
          <p className="text-[#4A4D4A] text-lg max-w-2xl mx-auto">
            Common questions about <strong>snake catcher services</strong> and <strong>snake help near me</strong>
          </p>
        </div>

        {/* FAQ Accordion */}
        <Accordion type="single" collapsible className="space-y-4" data-testid="faq-accordion">
          {faqs.map((faq, index) => (
            <AccordionItem 
              key={index} 
              value={`item-${index}`}
              className="bg-white border border-[#D8D4C7] rounded-2xl px-6 overflow-hidden"
              data-testid={`faq-item-${index + 1}`}
            >
              <AccordionTrigger className="text-left py-5 hover:no-underline">
                <span 
                  className="font-semibold text-[#1A1D1A] text-base md:text-lg pr-4"
                  style={{ fontFamily: 'Outfit, sans-serif' }}
                >
                  {faq.question}
                </span>
              </AccordionTrigger>
              <AccordionContent className="pb-5 text-[#4A4D4A] leading-relaxed">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        {/* Additional CTA */}
        <div className="mt-12 text-center p-8 bg-[#2A4B35] rounded-2xl">
          <p className="text-[#C5D4C9] mb-4">
            Still have questions?
          </p>
          <a 
            href="https://wa.me/918310755854?text=Hi%2C%20I%20have%20a%20question%20about%20your%20snake%20rescue%20services"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-[#25D366] hover:bg-[#20bd5a] text-white font-semibold px-6 py-3 rounded-full transition-all"
            data-testid="faq-whatsapp-btn"
          >
            Ask on WhatsApp
          </a>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
